export const AGE_GROUP_1 = {
  displayName: `5-8`,
  value: 1,
};

export const AGE_GROUP_2 = {
  displayName: `9-12`,
  value: 2,
};

export const AGE_GROUP_3 = {
  displayName: `13+`,
  value: 3,
};

export const AGES = [AGE_GROUP_1, AGE_GROUP_2, AGE_GROUP_3];



// WEBPACK FOOTER //
// ./library/app/data/ageGroups.js